var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/pro-regular-svg-icons";
import { faKey, faLockKeyhole, faShieldKeyhole, faCircleEuro, faLanguage, faGlobeAmericas, faFilePdf, faSearch, faClock, faSwatchbook, faSquareList, faCircle, faAdd, faList, faCalendar, faDownload, faWrench, faEye, faRefresh, } from "@fortawesome/pro-solid-svg-icons";
import { faGear } from "@fortawesome/pro-duotone-svg-icons";
import { useNavigate } from "react-router-dom";
import { decodeHtmlEntities } from "@/utils/htmlDecode";
export default function AdminWidget(_a) {
    var _b;
    var widget = _a.widget;
    var adminMenu = (_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.adminMenu;
    var navigate = useNavigate();
    //const selectedMenu = useAppSelector((state) => state.adminMenu.selected_menu);
    if (!adminMenu) {
        return _jsx("div", { children: "Chargement du menu administrateur..." });
    }
    var _c = adminMenu.ADMIN_GROUP_HEADER, adminGroupHeader = _c === void 0 ? [] : _c, _d = adminMenu.GROUP_HEADER, groupHeader = _d === void 0 ? [] : _d, _e = adminMenu.ITEM_URL, itemUrl = _e === void 0 ? [] : _e, _f = adminMenu.ICONS, icons = _f === void 0 ? [] : _f, _g = adminMenu.ITEM_HEADER_LABEL, itemHeaderLabel = _g === void 0 ? [] : _g, _h = adminMenu.ITEM_DESCRIPTION, itemDescription = _h === void 0 ? [] : _h;
    var getFontAwesomeIcon = function (icon) {
        var fontAwesomeIcon = faGear;
        switch (icon) {
            case "supervised_user_circle":
                fontAwesomeIcon = faUsers;
                break;
            case "vpn_key":
                fontAwesomeIcon = faLockKeyhole;
                break;
            case "security":
                fontAwesomeIcon = faShieldKeyhole;
                break;
            case "oauth":
                fontAwesomeIcon = faKey;
                break;
            case "monetization_on":
                fontAwesomeIcon = faCircleEuro;
                break;
            case "language":
                fontAwesomeIcon = faLanguage;
                break;
            case "locale":
                fontAwesomeIcon = faGlobeAmericas;
                break;
            case "pdf-settings":
                fontAwesomeIcon = faFilePdf;
                break;
            case "search":
                fontAwesomeIcon = faSearch;
                break;
            case "theme":
                fontAwesomeIcon = faSwatchbook;
                break;
            case "aobh-businesshours":
                fontAwesomeIcon = faClock;
                break;
            case "modules-and-subpanels":
            case "module-menu-filters":
                fontAwesomeIcon = faSquareList;
                break;
            case "title":
                fontAwesomeIcon = faCircle;
                break;
            case "add":
                fontAwesomeIcon = faAdd;
                break;
            case "list":
                fontAwesomeIcon = faList;
                break;
            case "schedule":
                fontAwesomeIcon = faCalendar;
                break;
            case "import":
                fontAwesomeIcon = faDownload;
                break;
            case "config":
                fontAwesomeIcon = faWrench;
                break;
            case "view":
                fontAwesomeIcon = faEye;
                break;
            case "refresh":
                fontAwesomeIcon = faRefresh;
                break;
            default:
                fontAwesomeIcon = faGear;
                break;
        }
        return fontAwesomeIcon;
    };
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "w-full" }, { children: adminGroupHeader &&
                Array.from(adminGroupHeader).map(function (key, index) { return (_jsxs("div", __assign({ className: "w-full m-8 text-center border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700" }, { children: [_jsx("h5", __assign({ className: "mb-2 text-3xl font-bold text-gray-900 dark:text-white text-left" }, { children: groupHeader[index][0].replace("<h3>", "").replace("</h3>", "") })), _jsx("p", __assign({ className: "mb-5 text-base text-gray-500 sm:text-lg dark:text-gray-400 text-left" }, { children: decodeHtmlEntities(groupHeader[index][1]) })), _jsx("div", __assign({ className: "grid grid-cols-3 gap-3" }, { children: Array.from(itemUrl[index]).map(function (key, item) { return (_jsx("div", { children: _jsxs("a", __assign({ href: itemUrl[index][item], onClick: function (e) {
                                        e.preventDefault();
                                        navigate(itemUrl[index][item]);
                                    }, className: "flex items-center p-3 text-base font-bold text-gray-900 hover:text-gray-500 rounded-lg bg-white hover:bg-gray-100 border border-gray-200 group hover:shadow dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white" }, { children: [_jsx(FontAwesomeIcon, { icon: getFontAwesomeIcon(icons[index][item]), size: "3x", className: "pr-3 text-blue-500" }), _jsxs("div", __assign({ className: "text-left rtl:text-right" }, { children: [_jsx("div", __assign({ className: "-mt-1 font-sans text-sm font-semibold" }, { children: decodeHtmlEntities(itemHeaderLabel[index][item]) })), _jsx("div", __assign({ className: "mb-1 text-blue-500 hover:text-gray-500 text-xs" }, { children: decodeHtmlEntities(itemDescription[index][item]) }))] }))] })) }, item)); }) }))] }), index)); }) })) }));
}
widgetsDictionary.register("widget/admin", {
    name: "Admin home",
    validation: true,
    selectable: true,
    display: AdminWidget,
});
